
import {inject, Injectable} from '@angular/core';
import {ErrorHandlingService} from "app/core/services/error.handling.service";
import {PermissionsService} from "app/core/services/permissions.service";
import {BehaviorSubject, Observable, tap} from "rxjs";
import {User} from "../../../core/types/smm/smm-person.types";
import {SMMFeatEnum} from "../../../core/types/permission.types";

@Injectable({providedIn: 'root'})
export class RecentPatientsService
{
    private readonly _permissionSrv: PermissionsService = inject(PermissionsService);
    private readonly _data: BehaviorSubject<User[]> = new BehaviorSubject([]);
    maxLength=6;

    /**
     * Constructor
     */
    constructor() {
        this.loadFromLocalStorage()
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for data
     */
    get data$(): Observable<User[]> {
        return this._data.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get data
     */
    loadFromLocalStorage(): void
    {
        if(!this._permissionSrv.can(SMMFeatEnum.core_cl_mgmt)){
            return;
        }
        const data:User[] = JSON.parse(localStorage.getItem('RECENT_ACCESED_PATIENTS'));
        if(data){
            this._data.next(data);
        }
    }

    storeToLocalStorage(){
        const data = JSON.stringify(this._data.getValue());
        localStorage.setItem('RECENT_ACCESED_PATIENTS', data);
    }

    add(user:User):void{
        if(!this._permissionSrv.can(SMMFeatEnum.core_cl_mgmt)){
            return;
        }
        const data:User[] = this._data.getValue();
        const index = data.findIndex(u => u.id === user.id);
        if(index !== -1){
            data.splice(index, 1);
        }
        data.unshift(user);

        if(data.length > this.maxLength){
            data.splice(data.length-1,1)
        }
        this._data.next(data);
        this.storeToLocalStorage();
    }

    public hasAny():boolean{
        return this._data.getValue()?.length > 0;
    }

}
